import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_electrical_outlets_used_for_plugging_in_corded_equipment_in'

export const dataPointDefinition = {
  retracedId: 'are_electrical_outlets_used_for_plugging_in_corded_equipment_in',
  name: 'Are electrical outlets used for plugging in corded equipment in wet or damp areas protected with GFCIs (ground-fault circuit-interrupters)?',
  description:
    'If the facility does not have wet or damp areas, answer Not Applicable.\r\r\n\r\r\nGFCIs are designed to protect people from hazardous ground faults that can arise from plugging in defective appliances or corded equipment. Applicable electrical codes generally indicate the requirements for GFCI. For example, the NFPA National Electrical Code (NFPA 70), requires that receptacles/outlets in the following areas have GFCI:\r\r\n- Industrial Space - bathrooms, on rooftops, in kitchens, outdoors (under some circumstances), at sinks, in garages, in laundries, and any other damp/wet locations; \r\r\n- Dwellings (e.g. dormitories) - bathrooms, garages, outdoors, crawlspaces, basements, kitchens, sinks, boathouses, bathtub/shower stall, and laundry areas.\r\r\nIf you have any of the above listed environments at the facility (e.g. bathrooms, kitchens, rooftops), and you do not have an GFCI outlet, answer No.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'ynna',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'ynna',
    },
    {
      name: 'Not Applicable',
      key: 'NOT_APPLICABLE',
      slcpIndex: 3,
      slcpOptionName: 'ynna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-ele-13',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 16600,
  sectionId: '2.2.9.9',
  impactArea: 'Electrical Safety',
  impactAreaId: 'ELECTRICAL_SAFETY',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
